"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createErrorMessage = createErrorMessage;
var _constants = require("../constants");
/**
 * A function that generates an error message based on provided error code and message parameters. It is used only internally.
 *
 * @param errorCode Error code.
 * @param errorMessages Object containing all possible error messages.
 * @param messageParameters Array of values that are used as message parameters.
 * @return Error message.
 */
function createErrorMessage(errorCode, errorMessages, messageParameters = []) {
  const errorMessage = errorMessages[errorCode];
  if (!errorMessage) {
    return '';
  }
  return `${errorCode}: ${errorMessage.replace(_constants.ERROR_MESSAGE_TOKEN_PATTERN, (match, index) => String(messageParameters[index]))}`;
}
